import { createSelector } from 'reselect';
import { OrderedMap, Map } from 'immutable';
import get from 'lodash/get';

import User from 'models/user';

const readProp = (slice, key, defaultValue) => {
  if (!slice) {
    return defaultValue;
  }
  if (typeof slice.get === 'function') {
    const val = slice.get(key);
    return val !== undefined ? val : defaultValue;
  }
  return get(slice, key, defaultValue);
};

export const getAccountState = state => get(state, 'account', null);

export const getUser = createSelector(
  [getAccountState],
  account => readProp(account, 'user', new User()),
);

export const getIsLoggedIn = createSelector(
  [getUser],
  user => Boolean(user && typeof user.isLoggedIn === 'function' ? user.isLoggedIn() : get(user, 'token')),
);

export const getVehicles = createSelector(
  [getAccountState],
  account => readProp(account, 'vehicles', OrderedMap()),
);

export const getSelectedVehicleId = createSelector(
  [getAccountState],
  account => readProp(account, 'selectedVehicleId', null),
);

export const getDefaultVehicleId = createSelector(
  [getAccountState],
  account => readProp(account, 'defaultVehicleId', null),
);

export const getSelectedVehicle = createSelector(
  [getAccountState, getVehicles, getSelectedVehicleId],
  (account, vehicles, selectedVehicleId) => {
    const directVehicle = readProp(account, 'vehicle', null);
    if (directVehicle) {
      return directVehicle;
    }
    if (selectedVehicleId && vehicles && typeof vehicles.get === 'function') {
      return vehicles.get(selectedVehicleId.toString()) || vehicles.get(selectedVehicleId) || null;
    }
    return null;
  },
);

export const getAccountErrors = createSelector(
  [getAccountState],
  account => readProp(account, 'errors', Map()),
);

export const getAccountActivated = createSelector(
  [getAccountState],
  account => Boolean(readProp(account, 'accountActivated', false)),
);

export const getEnterpriseInvite = createSelector(
  [getAccountState],
  account => readProp(account, 'enterpriseInvite', null),
);

export const getSignInMethod = createSelector(
  [getAccountState],
  account => readProp(account, 'signInMethod', ''),
);

export const getAccountSubmitting = createSelector(
  [getAccountState],
  account => Boolean(readProp(account, 'submitting', false)),
);
